<template>
  <div>
    <div v-if="$apollo.loading">
      <spinner />
    </div>
    <div v-else class="wrapper">
      <div class="title-screen">
        <span>Edit message</span>
      </div>
      <text-field v-model="form.title" label="Title" autofocus :validator="$v.form.title" />
      <textarea-field
        v-model="form.message"
        label="Message"
        height="300"
        :validator="$v.form.message"
      />
      <div class="button-container">
        <main-button text="Delete" color="red" @click="$emit('delete', initialValue.id)" />
        <div>
          <main-button text="Cancel" flat outline @click="$emit('cancel')" />
          <main-button text="Save" @click="updateMessage()" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from '../shared/spinner.vue'
import { required } from 'vuelidate/lib/validators'
import { submitGuard } from '../../utils'

export default {
  name: 'message-to-attendee-container',
  components: {
    Spinner,
  },
  props: {
    initialValue: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      form: this.initialValue,
    }
  },
  validations() {
    return {
      form: {
        title: { required },
        message: { required },
      },
    }
  },
  methods: {
    async updateMessage() {
      await submitGuard(this, async () => {
        const data = this.form
        data.id = Number(data.id)
        this.$emit('update', data)
      })
    },
  },
}
</script>

<style scoped>
@media screen and (max-width: 800px) {
  .title-screen {
    display: none;
  }
  .wrapper {
    margin-top: 1.5rem;
  }
}
.wrapper {
  max-width: 42.5rem;
}
.button-container {
  display: flex;
  justify-content: space-between;
}
.message-style {
  height: 200px;
}
</style>
